import { render, staticRenderFns } from "./DocumentFooterComponent.vue?vue&type=template&id=3c41b429&scoped=true&"
import script from "./DocumentFooterComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentFooterComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentFooterComponent.vue?vue&type=style&index=0&id=3c41b429&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c41b429",
  null
  
)

export default component.exports